<template>
    <div>
        <div>
            <b-form-checkbox @click="showBillingAddress" v-model="modelCheckbox">
                {{$t('co.address_data.different_payment_address')}}
            </b-form-checkbox>
        </div>
        <div v-if="showBillingAddress">
            <div class="row mb-3 mt-3">
                <b-form-group 
                    :label="$t('co.address_data.street')" 
                    label-for="faaren_invoice_street" 
                    class="col-12 col-md-5 mr-md-2 mb-2"
                >
                    <b-form-input
                        id="faaren_invoice_street"
                        name="invoice_street"
                        :placeholder="$t('co.address_data.street')"
                        type="text"
                        required
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    :label="$t('co.address_data.number')"
                    label-for="faaren_invoice_street_number"
                    class="col-12 col-md-5"
                >
                    <b-form-input
                        id="faaren_invoice_street_number"
                        name="invoice_street_number"
                        :placeholder="$t('co.address_data.number.placeholder')"
                        type="text"
                        required
                    ></b-form-input>
                </b-form-group>
            </div>

            <div class="row mb-2">
                <b-form-group 
                    :label="$t('co.address_data.post_code')" 
                    label-for="faaren_invoice_post_code" 
                    class="col-12 col-md-5 mr-md-2 mb-2"
                >
                    <b-form-input
                        id="faaren_invoice_post_code"
                        name="invoice_post_code"
                        :placeholder="$t('co.address_data.post_code.placeholder')"
                        type="text"
                        required
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    :label="$t('co.address_data.location')"
                    label-for="faaren_invoice_location"
                    class="col-12 col-md-5"
                >
                    <b-form-input
                        id="faaren_invoice_location"
                        name="invoice_location"
                        :placeholder="$t('co.address_data.location')"
                        type="text"
                        required
                    ></b-form-input>
                </b-form-group>
            </div>

            <div class="row mb-2">
                <b-form-group
                    :label="$t('co.address_data.country')"
                    label-for="faaren_country"
                    class="col-12 col-md-5 mr-md-2 mb-2"
                >
                    <b-form-select
                        id="faaren_invoice_country"
                        name="invoice_country"
                        v-model="country.value"
                        :state="country.state"
                        aria-describedby="delivery-country-error"
                    >
                        <b-form-select-option
                            v-for="option in country.options"
                            :value="option.value"
                            :key="option.value"
                        >
                            {{ $t(`countries.${option.text}`) }}
                        </b-form-select-option>
                    </b-form-select>
                </b-form-group>
            </div>
        </div>
    </div>
</template>

<script>
import countries from '../../stores/countries'

import {
    BFormInput, BFormGroup, BFormSelect, BFormSelectOption, BFormTextarea, BFormCheckbox
} from "bootstrap-vue"

export default {
    name: 'CheckoutLeadsAddress',
    components: {
        BFormInput,
        BFormGroup,
        BFormSelect,
        BFormSelectOption,
        BFormTextarea,
        BFormCheckbox
    },

    data() {
        return {
            modelCheckbox: false,
            country: {
                value: this.$root.whitelabel.state.contact.address.country,
                state: null,
                options: countries.entries
            }
        }
    },

    computed: {
        showBillingAddress() {
            return this.modelCheckbox
        }
    }
}
</script>